const OutgoingMessageIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15"
    height="15"
    fill="none"
    transform="matrix(0 1 1 0 0 0)"
    viewBox="0 0 16 16"
  >
    <path
      id="SVGRepo_iconCarrier"
      fill="#32b517"
      d="m9.164 9.664 6.25-6.25L12.586.586l-6.25 6.25L3.5 4 2 5.5V14h8.5l1.5-1.5z"
    ></path>
  </svg>
);

export default OutgoingMessageIcon;
